<template>
  <div class="msg-box-wrap" v-if="isErpLogin">
    <i class="msg-icon" @mouseenter.stop="msgHandel" @mouseleave="msgLeaveHandel">
      <div v-if="unreadCount" class="msg-badge" :class="{'msg-badge-more': unreadCount > 99}">{{ unreadCount> 99 ? '99+' : unreadCount }}</div>
    </i>
    <div id="msgDom" @mouseenter="msgListHandel" @mouseleave="msgLeaveHandel"></div>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
export default {
  props: {
    userNo: {
      type: String,
      default: null
    },
    language: {
      type: String,
      default: 'en_US'
    },
    channel: {
      type: String,
      default: null
    },
    boxPosition: {
      type: Object,
      default() {
        return {
          top: 50,
          right: -40
        }
      }
    }
  },
  data() {
    return {
      msgInstance: null,
      showMsg: false,
      unreadCount: null,
      toggleTimer: null
    }
  },
  computed:{
    isErpLogin(){
      return Cookies.get('lwms.lt')==='erp'
    }
  },
  mounted() {
    this.msgSDK('#msgDom', this.userNo)
  },
  methods: {
    msgSDK(dom, userNo) {
      const that = this
      var script = document.createElement('script');
      script.src = 'https://print-web.s3.cn-north-1.jdcloud-oss.com/message-outreach/pc-sdk-prod.js';
      document.body.appendChild(script);
      script.onload = function () {
        const options = {
          userNo: that.userNo, // 用户编码
          userType: 1, // 用户类型 1：erp
          channel: that.channel, // 渠道
          timezone: null, // 时区 UTC+8
        };
        const headers = {
          'LOP-DN': 'message.jdl.com.erp', // 网关服务域
          userNo: userNo, // 用户编码
          'Account-Type': 'erp', // 账号类型
          channel: 1, // 渠道
        };
        // const prefix = 'http://lop-test.jd.local/'; // 请求前缀
        const prefix = 'https://lop-proxy.jd.com'; // 请求前缀

        const index = '/'; // 首页路径
        const id = dom; // 挂载DOM 默认为 document.body

        new ProtectOutreach(id, {
          options,
          headers,
          prefix,
          boxPosition: that.boxPosition,
          index,
        }).then((instance) => {
          that.msgInstance = instance
          that.setLanguage(that.$i18n.locale)

          // instance.destroy() // 销毁事件
          instance.on('alert', (msgNo) => {
            that.showMsg = true
            that.msgLeaveHandel()
          }) 
          // 弹出事件
          instance.off('alert', (msgNo) => {
            that.showMsg = false
          })
          // 弹窗关闭事件
          instance.on('close-alert', (msgNo) => {
            that.showMsg = false
          })

          instance.on('unread-count', (count) => {
            that.unreadCount = count
          }) 
          // 未读数量事件
          instance.off('unread-count', (count) => {
          })
        });
      };
    },
    msgHandel(e) {
      const that = this
      clearTimeout(that.toggleTimer)
      this.msgInstance.toggleHistoryList(true)
    },
    msgLeaveHandel() {
      this.toggleTimer = setTimeout(() => {
          this.msgInstance.toggleHistoryList(false)
        }, 200)
    },
    msgListHandel(event) {
      const that = this
      if(this.showMsg) {
        return
      }
      clearTimeout(that.toggleTimer)
      this.msgInstance.toggleHistoryList(true)
    },
    setLanguage(lang) {
      // 词条设置
      const languageMap = {
         'zh_CN': {
            title: '消息中心',
            publisher: '发布人',
            publishedTime: '发布时间',
            gotIt: '知道了',
            important: '重要',
            language: 'zh-cn',
          },
          'en_US': {
            title: 'Message Center',
            publisher: 'Publisher',
            publishedTime: 'Published Time',
            gotIt: 'Got It',
            important: 'Important',
            language: 'en-us',
          }
        }
        this.msgInstance.setLanguage(languageMap[lang]?languageMap[lang]: 'en_US');
    }
  },
  watch: {
    '$i18n.locale'(newLocale) {
      this.setLanguage(newLocale) 
    }
  }
};
</script>
<style lang="scss">
.msg-box-wrap{
  position: relative;
  display: flex;
  align-items: center;
  width: 30px;
  height: 100%;
  margin: 0 10px;
  justify-content: center;
  .msg-icon{
    display: inline-block;
    width: 16px;
    height: 16px;
    background-size: 16px;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url('https://img12.360buyimg.com/imagetools/jfs/t1/224029/39/48151/1357/672c1f6fF6a3dae99/7f1a733cf7389a7f.png');
    cursor: pointer;
  }
  .msg-badge {
    position: absolute;
    // top: 0px;
    right: -10px;
    top: 50%;
    transform: translate(0px,-20px);
    /* z-index: 100; */
    background: #e1251b;
    border-radius: 10px;
    color: #fff;
    display: inline-block;
    font-size: 12px;
    height: 18px;
    line-height: 18px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    }
  .msg-badge-more {
    right: -19px;
  }
}
</style>